"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Collection = void 0;
const array_literal_1 = require("../../../../#lib/expression-tree/nodes/array-literal");
const syntax_kind_1 = require("../syntax-kind");
const ast_node_1 = require("./ast-node");
class Collection extends ast_node_1.AstNode {
    constructor(elements) {
        super(syntax_kind_1.SyntaxKind.CollectionLiteral);
        this.elements = elements;
    }
    get children() {
        return this.elements;
    }
    toExpressionTreeNode() {
        return new array_literal_1.ArrayLiteral(this.children.map((child) => child.toExpressionTreeNode()));
    }
}
exports.Collection = Collection;
//# sourceMappingURL=collection.js.map